import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import {FormattedMessage, injectIntl} from 'react-intl';
import Box from '../box/box.jsx';
import Modal from '../../containers/modal.jsx';
import styles from './tier-modal.css';

const TierModal = props => {
    return (
        <Modal
            className={styles.modalContent}
            contentLabel={
                <FormattedMessage
                    defaultMessage="TIF Studio: Starter Access"
                    description="Label for tier modal"
                    id="gui.tierModal.label"
                />
            }
            headerClassName={styles.header}
            overlayClassName={styles.modalOverlay}
            id="tierModal"
            onRequestClose={props.onRequestClose}
        >
            <Box className={styles.body}>
                <div className={styles.titleSection}>
                    <div className={styles.title}>
                        <FormattedMessage
                            defaultMessage="Starter Access"
                            description="Title for tier modal"
                            id="gui.tierModal.title"
                        />
                    </div>
                    <div className={styles.description}>
                        <FormattedMessage
                            defaultMessage="Unlock the full power of robot-building by upgrading your account. Your current daily limits are synced with your account."
                            description="Description for tier modal"
                            id="gui.tierModal.description"
                        />
                    </div>
                </div>

            <div className={styles.limitsContainer}>
                <div className={styles.limitItem}>
                    <span className={styles.limitIcon}>📦</span>
                    <span className={styles.limitText}>
                        <FormattedMessage
                            defaultMessage="Block Usage Limit"
                            description="Block limit label"
                            id="gui.tierModal.blockLabel"
                        />
                    </span>
                    <span className={styles.limitBadge}>Max 25</span>
                </div>
                <div className={styles.limitItem}>
                    <span className={styles.limitIcon}>⚡</span>
                    <span className={styles.limitText}>
                        <FormattedMessage
                            defaultMessage="Daily Code Uploads"
                            description="Upload limit label"
                            id="gui.tierModal.uploadLabel"
                        />
                    </span>
                    <span className={styles.limitBadge}>{props.uploadCount} / {props.uploadLimit}</span>
                </div>
                <div className={styles.limitItem}>
                    <span className={styles.limitIcon}>💾</span>
                    <span className={styles.limitText}>
                        <FormattedMessage
                            defaultMessage="Daily Project Downloads"
                            description="Download limit label"
                            id="gui.tierModal.downloadLabel"
                        />
                    </span>
                    <span className={styles.limitBadge}>{props.downloadCount} / {props.downloadLimit}</span>
                </div>
                <div className={styles.limitItem}>
                    <span className={styles.limitIcon}>🤖</span>
                    <span className={styles.limitText}>
                        <FormattedMessage
                            defaultMessage="AI Extension Usage"
                            description="AI usage label"
                            id="gui.tierModal.aiUsageLabel"
                        />
                    </span>
                    <span className={styles.limitBadge}>{props.aiUsageCount} / {props.aiUsageLimit}</span>
                </div>
                {/* <div className={styles.limitItem}>
                    <span className={styles.limitIcon}>📟</span>
                    <span className={styles.limitText}>
                        <FormattedMessage
                            defaultMessage="Serial Monitor Access"
                            description="Serial monitor restriction label"
                            id="gui.tierModal.serialMonitorLabel"
                        />
                    </span>
                    <span className={styles.limitBadge}>Unlocked</span>
                </div> */}
            </div>

                <div className={styles.footer}>
                    <button 
                        className={styles.upgradeButton}
                        onClick={() => {
                            window.open('https://tifstudio.in/index.html#pricing', '_blank');
                            props.onRequestClose();
                        }}
                    >
                        <FormattedMessage
                            defaultMessage="Upgrade to PRO"
                            description="Upgrade button text"
                            id="gui.tierModal.upgrade"
                        />
                    </button>
                    <div 
                        className={styles.secondaryText}
                        onClick={props.onRequestClose}
                    >
                        <FormattedMessage
                            defaultMessage="Maybe later, continue for now"
                            description="Cancel text"
                            id="gui.tierModal.cancel"
                        />
                    </div>
                </div>
            </Box>
        </Modal>
    );
};

TierModal.propTypes = {
    onRequestClose: PropTypes.func.isRequired,
    downloadCount: PropTypes.number,
    downloadLimit: PropTypes.number,
    uploadCount: PropTypes.number,
    uploadLimit: PropTypes.number,
    aiUsageCount: PropTypes.number,
    aiUsageLimit: PropTypes.number,
    tier: PropTypes.string
};

const mapStateToProps = state => ({
    tier: state.scratchGui.tier.tier,
    downloadCount: state.scratchGui.tier.downloadCount,
    downloadLimit: state.scratchGui.tier.downloadLimit,
    uploadCount: state.scratchGui.tier.uploadCount,
    uploadLimit: state.scratchGui.tier.uploadLimit,
    aiUsageCount: state.scratchGui.tier.aiUsageCount,
    aiUsageLimit: state.scratchGui.tier.aiUsageLimit
});

export default connect(mapStateToProps)(injectIntl(TierModal));

